(function ($, Drupal) {
  Drupal.behaviors.webform = {
    attach: function (context, settings) {

      $('form.styling-primary').each(function() {
        $(this).parents().eq(2).addClass('webform-container-primary');
      });
      $('.webform-survey-confirmation').each(function() {
        $(this).parents().eq(2).addClass('webform-container-primary');
      });

    }
  }
})(jQuery, Drupal);
